export default __webpack_public_path__ + "fffcc0dde9954b0ff28d0a1617340f0c.png";